import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/infrastructure/data";
import { motion } from "framer-motion";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function DefenseLogistics() {
  const products = [
    "Water and Wastewater Management Software",
    

  ];
  const data = {
    image: "/industries/infrastructure/water-and-wastewater-management-software.jpg", // Replace with the appropriate image URL
    intro: `Dive into sustainable water resource management with our Water and Wastewater Management Software. Explore how our technology ensures efficient water usage, optimal wastewater treatment, and environmental sustainability.`,
    keyFeatures: [
      {
        title: "Water Quality Monitoring",
        content: "Monitor water quality in real-time to ensure its safety and compliance with standards.",
      },
      {
        title: "Wastewater Treatment Optimization",
        content: "Optimize wastewater treatment processes for efficiency and environmental compliance.",
      },
      {
        title: "Leak Detection and Prevention",
        content: "Detect and prevent water leaks to reduce water loss and ensure optimal usage.",
      },
      {
        title: "Asset Performance Monitoring",
        content: "Monitor the performance of water assets to enhance longevity and efficiency.",
      },
      {
        title: "Regulatory Compliance Management",
        content: "Manage and ensure compliance with water management regulations and standards.",
      },
    ],
    howItWorks: `Discover the technology behind effective water and wastewater management, from real-time water quality monitoring to optimizing treatment processes and ensuring compliance.`,
    benefits: {
      title: "The benefits of Water and Wastewater Management Software",
      data: [
        "Sustainable Water Resource Management",
        "Enhanced Wastewater Treatment Efficiency",
        "Reduced Water Loss and Leakage",
        "Improved Asset Longevity",
      ],
    },
    industries: "Tailored for water utilities, municipal water departments, industrial water users, and environmental engineering firms.",
    stories: `Explore success stories of organizations that have optimized their water and wastewater management with our software.`,
    contactUs: `Connect with our team to discuss how Water and Wastewater Management Software can address your specific water resource challenges.`,
    futureDevelopments: `Stay updated on the latest features and innovations shaping the future of water and wastewater management.`,
    technology: `Learn about the compatibility of our software with other water management technologies and IoT devices.`,
    support: `Access training programs and support services to ensure effective implementation and utilization of Water and Wastewater Management Software.`,
    industry: `Discover how our software aligns with industry standards and regulatory compliance in water management.`,
    events: "Stay informed about industry events and collaborations driving advancements in water and wastewater management.",
    blog: `Explore our blog and knowledge hub for insights into water resource management, industry trends, and best practices.`,
    careers: `Discover career opportunities and join us in shaping the future of water and wastewater management technology.`,
  };
  
  
  
  

  
  
  
  
  const content = "Embark on an infrastructure evolution with us! Whether you're immersed in infrastructure development, construction technology, urban planning, or any facet of the infrastructure industry, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our infrastructure solutions align seamlessly with your goals, budget, and scope."
    return (
    <>
  <Head>
    <title>Water and Wastewater Management Software | Efficient Resource Management | Techbrain Networks</title>
    <meta name="description" content="Manage water and wastewater resources efficiently with Techbrain Networks Water and Wastewater Management Software. Our solutions support effective resource management and optimization." />
    <meta name="keywords" content="water management software, wastewater management, resource optimization, Techbrain Networks" />
    <meta property="og:title" content="Water and Wastewater Management Software | Efficient Resource Management | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Water and Wastewater Management Software offers efficient solutions for managing water and wastewater resources, supporting effective resource management and optimization." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/infrastructure/products/water-and-wastewater-management-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Water and Wastewater Management Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Water and Wastewater Management Software | Efficient Resource Management" />
    <meta name="twitter:description" content="Techbrain Networks Water and Wastewater Management Software provides efficient solutions for managing water and wastewater resources with advanced optimization tools." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/infrastructure/products/water-and-wastewater-management-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Water and Wastewater Management Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Techbrain Networks Water and Wastewater Management Software provides efficient solutions for managing water and wastewater resources with advanced optimization tools.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/infrastructure/products/water-and-wastewater-management-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
               <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#02966c"} />

      <AppbarIndustry title={"Infrastructure"} homeLink={'/industries/infrastructure'} link={'/industries/infrastructure/products'} />
      <HeroSection img={"/industries/infrastructure/water-and-wastewater-management-software.jpg"}> Water and Wastewater Management Software
</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#000806",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
        component={motion.div}
        initial={{ opacity: 0,y:20 }}
        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#02966c"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
         {/* Key Features Unleashed */}
         <Box
         component={motion.div}
         initial={{ opacity: 0,y:20 }}
         whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
         viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#02966c"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#02966c",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
        component={motion.div}
        initial={{ opacity: 0,y:20 }}
        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#02966c"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          component={motion.div}
         initial={{ opacity: 0,y:20 }}
         whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
         viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#02966c"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
       {/* Industries */}
       <Box
       component={motion.div}
       initial={{ opacity: 0,y:20 }}
       whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
       viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#02966c"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

        

        {/* Future Developments and Innovations*/}
 
        <Box
        component={motion.div}
        initial={{ opacity: 0,y:20 }}
        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#02966c"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in defense logistics and supply chain management technology
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
        component={motion.div}
        initial={{ opacity: 0,y:20 }}
        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#02966c"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
        component={motion.div}
        initial={{ opacity: 0,y:20 }}
        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#02966c"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
        component={motion.div}
        initial={{ opacity: 0,y:20 }}
        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#000806",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#02966c"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
        component={motion.div}
        initial={{ opacity: 0,y:20 }}
        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        viewport={{ once: true,amount:.5 }}
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#02966c",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
             <Box
            sx={{
              width: ["100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#02966c"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      
      <FooterIndustry ourProducts={ourProducts} color={"#02966c"} bg={"#000806"} />
    </>
  );
}

export default DefenseLogistics;
